import { Component } from '@angular/core';
import { AtsNotificationService } from '@ats/notifications';
import { Observable } from 'rxjs';

@Component({
    selector: 'alpine-testing-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
	loading$: Observable<boolean>;

	constructor(private notifications: AtsNotificationService) {
		this.loading$ = this.notifications.loading$;
	}
}
